export default __webpack_public_path__ + "static/media/trash-small.1c19c7cb.svg";